import { HStack } from '@chakra-ui/react';
import React from 'react';
import CustomButton from '../CustomButton';

export type TTabButtonOption = {
  onClick: () => void;
  labelValue: string;
  labelDisplay: string;
};

interface Props {
  options: TTabButtonOption[];
  selectedOptionValue: string;
}

const TabButtons = ({ options, selectedOptionValue }: Props) => {
  return (
    <HStack
      backgroundColor={'white'}
      padding={'5px'}
      borderRadius={'8px'}
      gap={'10px'}
      boxShadow={'0px 2px 2px 0px #7C9EBC80'}
    >
      {options.map((option) => (
        <CustomButton
          key={option.labelDisplay}
          label={option.labelDisplay.toUpperCase()}
          onClick={option.onClick}
          backgroundColor={selectedOptionValue === option.labelValue ? 'primary.500' : 'white'}
          labelColor={selectedOptionValue === option.labelValue ? 'white' : 'text.mediumBlue'}
          isTransparent={selectedOptionValue !== option.labelValue}
          style={{ minWidth: '170px' }}
          labelStyle={{ fontWeight: 900, fontSize: '12px', lineHeight: '14px' }}
          noShadow
        />
      ))}
    </HStack>
  );
};

export default TabButtons;
